import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { navigate } from 'gatsby'
import { Typography } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import SEO from './seo'
import IconBack from '../img/icon_back.svg'
import IconCerrar from '../img/icon-cerrar-1-blanco.png'
// import MenuBottom from './menus/menu-bottom'
import Header from './common/header'
import './layout.css'

const Layout = ({
  children,
  bannerTitle,
  bannerRoute,
  withClose,
  withIcon,
  withSubHeader,
}) => {
  const useStyles = makeStyles(theme => ({
    container: {
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    MuiTitleContainer: {
      height: '119px',
      minHeight: '119px',
      flexBasis: '0PX',
      width: '100%',
      textAlign: 'center',
      display: 'flex',
      backgroundColor: theme.palette.primary.main,
      position: 'relative',
      marginBottom: '-115px',
    },
    MuiImage: {
      height: '50px',
      justifyContent: 'flex-end',
      marginTop: '15px',
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        marginTop: '22px',
      },
    },
    MuiWelcomeText: {
      marginTop: '30px',
      color: theme.palette.surface.surface_0,
      textAlign: 'center',
    },
    MuiColor: {
      backgroundColor: '#ebebec',
    },
  }))

  const classes = useStyles()

  const handleBack = () => {
    navigate(bannerRoute)
  }
  return (
    <div className={classes.MuiColor}>
      <SEO />
      <Grid container justify="center">
        <Container maxWidth="xl" className={classes.container}>
          <Header saldo="Tu saldo $100" cambio="Q7.76" />
          {withSubHeader && (
            <Grid item sm={12} className={classes.MuiTitleContainer}>
              {withIcon ? (
                <Grid xs={3} md={2} item>
                  {withClose ? (
                    <img
                      className={classes.MuiImage}
                      onClick={handleBack}
                      src={IconCerrar}
                      alt="oky"
                    />
                  ) : (
                    <img
                      className={classes.MuiImage}
                      onClick={handleBack}
                      src={IconBack}
                      alt="oky"
                    />
                  )}
                </Grid>
              ) : null}
              <Grid xs={withIcon ? 7 : 12} md={withIcon ? 8 : 12}>
                <Typography
                  component="h1"
                  variant="h5"
                  className={classes.MuiWelcomeText}
                >
                  {bannerTitle}
                </Typography>
              </Grid>
            </Grid>
          )}
          <main>{children}</main>
          {/* {withFooter ? <MenuBottom /> : null} */}
        </Container>
      </Grid>
    </div>
  )
}

Layout.defaultProps = {
  withFooter: true,
}

export default Layout
